import _ from "lodash";
import Calendar from "react-calendar";
import {Schedule} from "@/entity/Schedule";
import globalStyle from "@/styles/Global.scss";
import style from "./MCalendar.scss";
import {useState} from "react";
import dayjs from "dayjs";

const MCalendar = ({ onChange = () => {}, schedules = [], canEdit = false, toEdit = () => {}, toAddToDay = () => {}}) => {
  const [currentSchedule, setCurrentSchedule] = useState()

  const tileContents = ({ date, view }) => {
    if (view !== 'month') {
      return <></>
    }
    const toDay = _.filter(schedules, { date })[0] || new Schedule({})
    return (
      <div>
        { toDay.businessHour }
      </div>
    );
  }

  const days = () => {
    return schedules.map((s) => { return s.date; });
  }

  const onclick = (e) => {
    const toDay = _.filter(schedules, { date: e })[0] || new Schedule({ date: e })
    setCurrentSchedule(toDay)
  }

  const editLink = ({currentSchedule}) => {
    const isEdit = currentSchedule.id !== undefined
    const handler = isEdit ? toEdit : toAddToDay
    return (<>
      <span
        className={globalStyle.link}
        onClick={() => handler({schedule: currentSchedule})}
      >{isEdit ? '編集' : '登録'}
      </span>
    </>)
  }

  return (
    <>
      <div className={style.calendarContainer}>
        <Calendar calendarType={'gregory'} onClickDay={onclick} onChange={onchange} value={days()} tileContent={tileContents} />
        { currentSchedule &&
          <div className={style.schedulePanel}>
            <div>
              { dayjs(currentSchedule.date).format("YYYY年MM月DD") }
              { canEdit && editLink({ currentSchedule }) }
            </div>
            <div>{ currentSchedule.holiday ? '休業日' : '営業日' }</div>
            <div>営業時間：{ currentSchedule.businessHour }</div>
            <div>{ currentSchedule.memo }</div>
          </div>
        }
      </div>
    </>
  )
}

export default MCalendar;
